import styled, { CSSObject } from '@emotion/styled';
import { getBackgroundTheme } from '../../../../style';
import breakpoints from '../../../../theme/material/breakpoints';
import { isDarkMode, IsMobileViewPort, tabletWidth, ternaryFunc } from '../../../../utils/helpers';
import { CustomStyledProps } from 'style/style';

const PhotoAspectRatio = styled('div')(
  (): CSSObject => ({
    paddingTop: '133%',
    position: 'relative',
    border: isDarkMode() ? '0' : '1px solid #DAE1E9',
    borderRadius: 6,
  }),
  ({ isPrivate }: CustomStyledProps) => isPrivate && { backgroundColor: getBackgroundTheme().gallery }
);

const PhotoStatusTitle = styled('span')({
  fontSize: 13,
  fontWeight: 400,
  verticalAlign: 'middle',
  paddingLeft: '5px',
});

const PhotoStatus = styled('div')(
  {
    padding: '3px 0',
    backgroundColor: 'rgba(13,92,147,0.9)',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'left',
    color: '#fff',
    cursor: 'auto',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
  ({ isCenterAlign }: CustomStyledProps) => ({ textAlign: isCenterAlign ? 'center' : 'left' })
);

const Photo = styled('div')(
  {
    width: '100%',
    height: '100%',
    borderRadius: 6,
    position: 'absolute',
    top: '0px',
    left: '0px',
  },
  ({ imgUrl }: CustomStyledProps) => {
    return {
      backgroundImage: `url(${imgUrl})`,
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    };
  }
);

const PrivateTotal = styled('div')({
  position: 'absolute',
  top: '0',
  margin: '0 auto',
  fontWeight: 'bold',
  width: '100%',
  textAlign: 'center',
  color: '#3a9be1',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  boxSizing: 'border-box',
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const VideoInProgress = styled('div')(({ photoHeight }) => ({
  boxSizing: 'border-box',
  border: '1px solid #C0103E',
  background: 'repeating-linear-gradient(75deg, #F2F2F2 0 15px, #DEDEDE 15px 30px)',
  borderRadius: 4,
  textAlign: 'center',
  cursor: 'pointer',
  paddingTop: '24%',
  width: '100%',
  height: '100%',
  color: '#808080',
  fontWeight: 'bold',
  position: 'absolute',
  top: 0,
  minHeight: photoHeight ? photoHeight : ternaryFunc(tabletWidth, 237, '100%'),
  [breakpoints.down('sm')]: {
    minHeight: photoHeight ? photoHeight : ternaryFunc(IsMobileViewPort, 148, 237),
    fontSize: 12,
    paddingTop: 20,
  },
}));

const MediaPlayWrap = styled('div')({
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
});

export { Photo, PhotoAspectRatio, PhotoStatusTitle, PhotoStatus, PrivateTotal, VideoInProgress, MediaPlayWrap };
